/* AMBRA | assets/ambra-dodatki.js | v1.2 | 10.10.2026 — karuzela „Uzupełnij zamówienie”.
   Ładowany (defer) tylko przez snippets/ambra-dodatki.liquid, gdy karuzela się wyrenderowała.
   Jedna przestrzeń: window.AmbraDodatki. Bez nadpisywania fetch/XHR, bez MutationObserver,
   nasłuchy tylko na własnym kontenerze [data-ambra-dod] (+ ResizeObserver na własnym torze).
   Koszyk — wyłącznie publiczne API motywu (patrz USTALENIA-motyw.md):
     „Dodaj”  → POST {cart_add_url}.js {items:[{id,quantity:1,properties:{_dodatki:źródło}}], sections:'cart-drawer'}
     „Dodano ✓” (2. klik) → POST {cart_change_url}.js {id:key, quantity:n-1, sections:'cart-drawer'}
     potem eventBus.emit('update:cart:drawer', odpowiedź) → szuflada, kwoty, pasek progresu, BOGO;
     GET {cart_url}.js → wetheme.updateCartCount(cart) → licznik.
   POMIAR: właściwość pozycji _dodatki = źródło (wyjatek/regula/baza) — jak znacznik _quiz; Shopify Flow
     „Order created” → właściwość _dodatki → tag „dodatki”. Osobna linia w koszyku (key unikalny) → cofnięcie po key.
   Szuflady NIE otwieramy. Błąd dodania → przycisk wraca do stanu sprzed kliknięcia + komunikat.
   „Dodano” ≠ „odświeżono”: błąd odświeżenia NIE cofa stanu przycisku (produkt już jest w koszyku).
   Cofnięcie, gdy pozycję usunięto już w szufladzie (404) → przycisk wraca na „Dodaj” bez komunikatu.
   Kafel to <form action=/cart/add> — bez JS działa zwykły zapis; JS przejmuje submit (preventDefault).
   ?dodatki=debug → kafle pokazują źródło, konsola: lista pominiętych z Liquid. */
(function () {
  'use strict';
  if (window.AmbraDodatki) { window.AmbraDodatki.init(); return; }

  var R = window.routes || {};
  var U = {
    add: (R.cart_add_url || '/cart/add') + '.js',
    change: (R.cart_change_url || '/cart/change') + '.js',
    cart: (R.cart_url || '/cart') + '.js'
  };
  var DEBUG = /[?&]dodatki=debug\b/.test(location.search);
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { j.status = j.status || r.status; throw j; } return j; });
    });
  }

  /* Odświeżenie motywu tym samym mechanizmem, co jego blok cross-sell. */
  function odswiez(json) {
    var bus = window.eventBus;
    try {
      if (bus && typeof bus.emit === 'function') {
        if (json && json.sections) bus.emit('update:cart:drawer', json);
        else bus.emit('render:cart:drawer');
      }
    } catch (err) { if (DEBUG) console.warn('[AmbraDodatki] eventBus', err); }
    return fetch(U.cart, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(cart);
      return cart;
    });
  }

  /* Stan przycisku-ikony: data-stan=dodano (tło czarne), data-faza=ok przez 1,2 s (✓), potem × + etykieta „usuń”. */
  function ustaw(btn, on, t) {
    var f = btn.closest('[data-ambra-dod-form]');
    var pod = f && f.querySelector('[data-ambra-dod-pod]');
    clearTimeout(btn._faza);
    if (on) {
      btn.setAttribute('data-stan', 'dodano');
      btn.setAttribute('data-faza', 'ok');
      btn._faza = setTimeout(function () { btn.removeAttribute('data-faza'); }, 1200);
    } else {
      btn.removeAttribute('data-stan');
      btn.removeAttribute('data-faza');
    }
    if (f) { if (on) f.setAttribute('data-stan', 'dodano'); else f.removeAttribute('data-stan'); }
    if (pod) pod.hidden = !on;
    var et = (on ? t.ariaCofnij : t.ariaDodaj) + ' ' + btn.dataset.nazwa;
    btn.setAttribute('aria-label', et);
    btn.setAttribute('title', on ? t.ariaCofnij.replace(/:$/, '') : t.dodaj);
  }

  function init() {
    var roots = document.querySelectorAll('[data-ambra-dod]:not([data-ambra-dod-ok])');
    Array.prototype.forEach.call(roots, start);
  }

  function start(root) {
    root.setAttribute('data-ambra-dod-ok', '');
    var d = root.dataset;
    var t = { dodaj: d.tDodaj, dodano: d.tDodano, ariaDodaj: d.tAriaDodaj, ariaCofnij: d.tAriaCofnij, ok: d.tOk, usun: d.tUsun, blad: d.tBlad };
    var tor = root.querySelector('[data-ambra-dod-tor]');
    var nav = root.querySelector('[data-ambra-dod-navbox]');
    var strz = root.querySelectorAll('[data-ambra-dod-nav]');
    var status = root.querySelector('[data-ambra-dod-status]');
    var kolejka = Promise.resolve();

    function mow(txt, blad) {
      status.classList.toggle('ambra-dod__status--blad', !!blad);
      status.textContent = txt;
    }

    var czeka = false;
    function strzalki() {
      if (!tor || !nav || czeka) return;
      czeka = true;
      requestAnimationFrame(function () {
        czeka = false;
        var max = tor.scrollWidth - tor.clientWidth;
        nav.hidden = max <= 5;
        strz[0].disabled = tor.scrollLeft <= 5;
        strz[1].disabled = tor.scrollLeft >= max - 5;
      });
    }

    function klik(btn) {
      if (btn.getAttribute('aria-busy') === 'true') return;
      var bylo = btn.getAttribute('data-stan') === 'dodano';
      btn.setAttribute('aria-busy', 'true');
      ustaw(btn, !bylo, t);
      mow('');
      kolejka = kolejka.then(function () {
        var zad = bylo
          ? post(U.change, { id: btn.dataset.key, quantity: Math.max(0, (+btn.dataset.ilosc || 1) - 1), sections: 'cart-drawer' })
          : post(U.add, { items: [{ id: +btn.dataset.variantId, quantity: 1, properties: { _dodatki: btn.dataset.zrodlo } }], sections: 'cart-drawer' });
        return zad.then(function (j) {
          if (!bylo) {
            var it = (j.items && j.items[0]) || {};
            btn.dataset.key = it.key || btn.dataset.variantId;
            btn.dataset.ilosc = it.quantity || 1;
          }
          mow((bylo ? t.usun : t.ok) + ' ' + btn.dataset.nazwa);
          return odswiez(j).catch(function (err) { if (DEBUG) console.warn('[AmbraDodatki] odświeżenie', err); });
        }).catch(function (e) {
          if (bylo && e && e.status === 404) { ustaw(btn, false, t); return; }
          ustaw(btn, bylo, t);
          mow((e && e.description) || t.blad, true);
        }).then(function () { btn.removeAttribute('aria-busy'); });
      });
    }

    root.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-ambra-dod-form]');
      if (!f || !root.contains(f)) return;
      e.preventDefault();
      var b = f.querySelector('[data-ambra-dod-add]');
      if (b) klik(b);
    });
    root.addEventListener('click', function (e) {
      var n = e.target.closest('[data-ambra-dod-nav]');
      if (n && tor) tor.scrollBy({ left: (+n.dataset.ambraDodNav) * tor.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    });

    if (tor) {
      tor.addEventListener('scroll', strzalki, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(strzalki).observe(tor);
      strzalki();
    }

    if (DEBUG) {
      root.classList.add('ambra-dod--debug');
      var dbg = root.querySelector('[data-ambra-dod-debug]');
      var lista = [];
      try { lista = JSON.parse(dbg.textContent).split(';').filter(Boolean); } catch (err) {}
      console.info('[AmbraDodatki] pominięte (id:źródło:powód):', lista);
    }
  }

  window.AmbraDodatki = { init: init, wersja: '1.2' };
  init();
})();
